import React from "react";

export default function CheckBoxChecked(): React.JSX.Element {
  return (
    <div className="scd-checkbox-checked">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 30 30">
        <path className="st0" d="M30,0H0v30h30V0z" />
        <path
          className="st1"
          d={
            "M24.8,7.7c0.3,0.3,0.3,0.7,0,0.9L11.6,22.3c-0.1,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.5-0.3L5.1,13" +
            "c-0.2-0.3-0.1-0.7,0.3-0.9c0.3-0.2,0.8-0.1,0.9,0.3l4.9,8.4l12.6-13C24.1,7.4,24.5,7.4,24.8,7.7z"
          }
        />
      </svg>
    </div>
  );
}
